import MainFiltersComponent from "./MainFilters";
import OpenFiltersComponent from "./OpenFilters";
import OpenSearchComponent from "./OpenSearch";
import { Group } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const MainFilters = MainFiltersComponent as any;
const OpenFilters = OpenFiltersComponent as any;
const OpenSearch = OpenSearchComponent as any;

export type MainViewProps = {
  openFilters: () => void;
  openSearch: () => void;
};

const MainView: React.FC<MainViewProps> = (props) => {
  const { openFilters, openSearch } = props;
  return (
    <>
      <Group>
        <MainFilters />
      </Group>
      <Group>
        <OpenFilters handleOpen={() => openFilters()} />
        <OpenSearch handleOpen={() => openSearch()} />
      </Group>
    </>
  );
};

export default MainView;
